import {AttrsSchema, Component} from 'panel';

import {Section} from 'common/components/items-menu/types';
import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {FilterComplexConfig} from '../types';
import css from './index.styl?inline';
import template from './index.jade';

interface ComplexFilterState {
  open: boolean;
}

interface FilterBarComplexFilterAttrs extends FilterComplexConfig {
  name: string;
  sections: Section[];
}

export class FilterBarComplexFilter extends Component<ComplexFilterState, FilterBarComplexFilterAttrs> {
  static get attrsSchema(): AttrsSchema<FilterBarComplexFilterAttrs> {
    return {
      name: `string`,
      sections: `json`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        open: false,
      },
      helpers: {
        handleMenuChange: ({detail}) => {
          if (detail.state === `closed`) {
            this.update({open: false});
          }
        },
        clickedFilterButton: () => this.update({open: true}),
        handleFilterItemClick: ({detail}) => {
          const {filterName, label} = detail.item;
          this.dispatchEvent(
            new CustomEvent(`changeFilter`, {
              detail: {
                ...detail,
                name: filterName,
                label,
              },
            }),
          );
        },
        getSelectedItems: () => {
          // this works for the use case where there's only one section where displayAllSelectOne
          // is false so take the first one, might need to revisit this if this is used more broadly
          const [selectedSection] = this.attr(`sections`).filter((section) => !section.displayAllSelectOne);
          return selectedSection?.items?.filter((item) => item.isSelected) || [];
        },
      },
    };
  }
}

export const FilterBarComplexFilterEl = defineAndMakeJsxFactory(`filter-bar-complex-filter`, FilterBarComplexFilter);
